import type { ReactNode } from "react";
import {
  ApplicationPanelBody,
  ApplicationPanelChip,
  ApplicationPanelFact,
  ApplicationPanelFacts,
  ApplicationPanelHeader,
  ApplicationPanelHeading,
  ApplicationPanelIcon,
  ApplicationPanelSurface
} from "./work-policy-application.styles";

interface WorkPolicyApplicationPanelProps {
  icon: "clock" | "calendar" | "week";
  title: string;
  description: string;
  modeLabel: string;
  policyName: string;
  startDate: string;
  endDate: string;
  children: ReactNode;
}

const icons = {
  clock: "◷",
  calendar: "▦",
  week: "▤"
} as const;

export function WorkPolicyApplicationPanel({
  icon,
  title,
  description,
  modeLabel,
  policyName,
  startDate,
  endDate,
  children
}: WorkPolicyApplicationPanelProps) {
  const headingId = `work-policy-panel-${icon}-title`;
  return (
    <ApplicationPanelSurface role="region" aria-labelledby={headingId}>
      <ApplicationPanelHeader>
        <ApplicationPanelIcon aria-hidden="true">{icons[icon]}</ApplicationPanelIcon>
        <ApplicationPanelHeading>
          <h3 id={headingId}>{title}</h3>
          <p>{description}</p>
          <ApplicationPanelFacts>
            <ApplicationPanelChip>{modeLabel}</ApplicationPanelChip>
            <ApplicationPanelFact>정책 · {policyName}</ApplicationPanelFact>
            <ApplicationPanelFact>
              신청기간 · {startDate} ~ {endDate}
            </ApplicationPanelFact>
          </ApplicationPanelFacts>
        </ApplicationPanelHeading>
      </ApplicationPanelHeader>
      <ApplicationPanelBody>{children}</ApplicationPanelBody>
    </ApplicationPanelSurface>
  );
}
